module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('h3', [_vm._v("Bundão")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-129406b0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/enterprise/modules/Result/PartialModalAlertDetails.vue
// module id = 331
// module chunks = 0